import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	upgrade: {
		id: 'jsw-upgrade-button.upgrade',
		defaultMessage: 'Upgrade',
		description: 'Label on a button for upgrading the product edition',
	},
});
